import requests from "../util";

const { request } = requests;

export const getTimeBoundDeliveryStats = (params) =>
  request({
    url: "/api/v1/report/customClient/timeBoundDeliveryStatsBST2",
    method: "post",
    body: params,
  });
